import { SET_USER, SET_BATONS } from "./Constants";

export const initialState = {
	user: null,
	batons: [],
};

const reducer = (state, action) => {
	switch (action.type) {
		case SET_USER:
			return {
				...state,
				user: action.payload.user,
			};
		case SET_BATONS:
			return {
				...state,
				batons: action.payload.batons,
			};
		default:
			return state;
	}
};

export default reducer;
